import React from "react"
import { semantic, hexToRgba } from '@lexody/design-tokens'

import StandardModal from '../../app_components/StandardModal'
import { withStyles } from '@material-ui/core/styles'
import Slider from '@material-ui/core/Slider'

const StyledSlider = withStyles({
  root: {
    color: hexToRgba(semantic.primary.surface.default, 0.5),
    height: 8,
    padding: '12px 0',
  },
  thumb: {
    height: 20,
    width: 20,
    backgroundColor: semantic.primary.surface.default,
    marginTop: -10,
    marginLeft: -10,
    boxShadow: '0 2px 6px rgba(30, 37, 40, 0.2)',
    '&:focus, &:hover, &$active': {
      boxShadow: '0 2px 8px rgba(30, 37, 40, 0.28)',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 6,
    borderRadius: 6,
  },
  rail: {
    height: 6,
    borderRadius: 6,
    opacity: 0.35,
  },
})(Slider)

function formatAgeLabel(age) {
  return age >= 100 ? '99+' : String(age)
}

class AgeFilter extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      needAgeModal: false,
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleProPopup = this.handleProPopup.bind(this)
  }

  handleChange(event, value) {
    if (!this.props.premiumUser) {
      this.props.toggleProModal('filter')
    } else {
      this.props.updateAge(value[0], value[1])
    }
  }

  handleProPopup() {
    if (!this.props.premiumUser) {
      this.props.toggleProModal('filter')
    }
  }

  render() {
    const min = this.props.min_age_difference
    const max = this.props.max_age_difference

    return (
      <section className="matchFiltersModal__card" onClick={() => this.handleProPopup()}>
        {this.state.needAgeModal && (
          <StandardModal onClose={() => this.setState({ needAgeModal: false })}>
            <h3 className="matchFiltersModal__alertTitle">Add your birthday first</h3>
            <p className="matchFiltersModal__alertText">
              Save your birthday in settings to use the age filter.
            </p>
            <button
              type="button"
              className="button_primary"
              onClick={() => window.location.assign('/edit')}
            >
              Go to settings
            </button>
          </StandardModal>
        )}

        <div className="matchFiltersModal__sectionHeader">
          <h3 className="matchFiltersModal__sectionTitle">Age range</h3>
          <span className="matchFiltersModal__proBadge">Pro</span>
        </div>
        <p className="matchFiltersModal__ageValue">
          {formatAgeLabel(min)} – {formatAgeLabel(max)} years
        </p>
        <div className="matchFiltersModal__slider">
          <StyledSlider
            value={[min, max]}
            min={18}
            max={152}
            onChange={this.handleChange}
            valueLabelDisplay="off"
            aria-labelledby="match-age-range-slider"
          />
        </div>
      </section>
    )
  }
}

export default AgeFilter
